import { Button, Group, Modal, Text } from '@mantine/core';
// import { showNotification } from '@mantine/notifications';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// import { cancelPlan } from '@mygpt/app/apis';
import { useModals } from '@/hooks/useModals';
import { useGPTStore } from '@/store';

// 展示用户当前的订阅相关信息
export const CurrentSubscriptionModal = () => {
  const { t } = useTranslation();
  const { subscriptionModalOpened, toggle } = useModals();
  const { paymentInfo } = useGPTStore();
  const navigate = useNavigate();

  const format = (time?: string) => {
    if (!time) return '';
    return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
  };

  // const unsubscribe = async () => {
  //   // 如果是订阅成功状态
  //   const isSubscription = paymentInfo?.type === 'payment_intent_succeeded';
  //   if (isSubscription) {
  //     if (!window.confirm(t('pricing.current_subscription.cancel_confirm')!)) {
  //       return;
  //     }
  //     try {
  //       await cancelPlan();
  //       // 重新刷新订阅信息
  //       setTimeout(() => {
  //         getPaymentInfo();
  //       }, 1000);
  //       showNotification({
  //         message: t('pricing.current_subscription.cancel_success'),
  //       });
  //     } catch (error) {
  //       showNotification({
  //         message: t('pricing.current_subscription.cancel_failed'),
  //         color: 'red',
  //       });
  //     }
  //     return;
  //   }
  // };

  const upgrade = () => {
    toggle('subscriptionModalOpened', false);
    navigate('/pricing');
  };

  // 订阅是否取消
  // const canceled = paymentInfo?.type === 'customer_subscription_deleted';

  const hasSubscription = paymentInfo?.order !== 0;

  return (
    <Modal
      opened={subscriptionModalOpened}
      onClose={() => toggle('subscriptionModalOpened', false)}
      title={
        <Text fz="lg" fw={500}>
          {t('pricing.current_subscription.title')}
        </Text>
      }
      centered
      size="lg"
      padding="md"
    >
      <div className="flex items-center">
        <Text fz="md" fw={500} className="shrink-0">
          {t('pricing.current_subscription.product_name')}：
        </Text>
        <div className="flex items-center whitespace-pre-line">
          {t(`pricing.plan_${paymentInfo?.order || 0}.title`)}
        </div>
      </div>
      <div className="flex items-center my-4">
        <Text fz="md" fw={500} className="shrink-0">
          {t('pricing.current_subscription.used_tokens')}：
        </Text>
        <div className="flex items-center whitespace-pre-line">
          {paymentInfo?.used_tokens} / {paymentInfo?.max_tokens}
        </div>
      </div>
      <div className="flex items-center my-4">
        <Text fz="md" fw={500} className="shrink-0">
          {t('pricing.current_subscription.used_msgs')}：
        </Text>
        <div className="flex items-center whitespace-pre-line">
          {paymentInfo?.used_questions} / {paymentInfo?.max_questions}
        </div>
      </div>

      {hasSubscription ? (
        <>
          {/* {paymentInfo?.type && (
            <div className="flex items-center my-4">
              <Text fz="md" fw={500}>
                {t('pricing.current_subscription.status')}：
              </Text>
              <Text fz="md">{t(`pricing.current_subscription.${paymentInfo?.type}`)}</Text>
            </div>
          )} */}
          {paymentInfo?.canceled_at && (
            <div className="flex items-center my-4">
              <Text fz="md" fw={500}>
                {t('pricing.current_subscription.cancel_time')}：
              </Text>
              <Text fz="md">{format(paymentInfo?.canceled_at)}</Text>
            </div>
          )}
          <div className="flex items-center my-4">
            <Text fz="md" fw={500}>
              {t('pricing.current_subscription.bill_start')}：
            </Text>
            <Text fz="md">{format(paymentInfo?.created_at)}</Text>
          </div>
          <div className="flex items-center">
            <Text fz="md" fw={500}>
              {t('pricing.current_subscription.bill_end')}：
            </Text>
            <Text fz="md">{format(paymentInfo?.end_at)}</Text>
          </div>
          {/* {!canceled && (
            <Group justify="flex-end">
              <Button variant="subtle" color="red" onClick={unsubscribe}>
                {t('pricing.unsubscribe_button')}
              </Button>
            </Group>
          )} */}
        </>
      ) : (
        <Group justify="flex-end">
          <Button variant="subtle" onClick={upgrade}>
            {t('pricing.upgrade_button')}
          </Button>
        </Group>
      )}
    </Modal>
  );
};
